<template>
  <div>
    <ValidationObserver ref="form">
      <form-toolbar :title="getTitle()"
                    :showSubmitButton="true"
                    :onCloseClick="close"
                    :onSubmitClick="submit"
                    :isSubmitting="isLoading" />
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="12" sm="5">
              <ValidationProvider name="Reported By" rules="required|max:100" v-slot="{ errors }">
                <v-text-field v-model="safetyObservation.reporterName" label="Reported By" counter="100" :error-messages="errors" />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="3">
              <v-dialog ref="dateMenu" v-model="dateMenu" transition="scale-transition" width="unset">
                <template v-slot:activator="{ on }">
                  <ValidationProvider name="Date" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="safetyObservation.date" label="Date" readonly v-on="on" clearable :error-messages="errors" />
                  </ValidationProvider>
                </template>
                <v-date-picker v-model="safetyObservation.date" @change="observationDateSelected" no-title scrollable>
                  <v-spacer />
                  <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="2">
              <v-dialog ref="timeMenu" v-model="timeMenu" transition="scale-transition" max-width="300">
                <template v-slot:activator="{ on }">
                  <ValidationProvider name="Time" rules="required" v-slot="{ errors }">
                    <v-text-field v-model="safetyObservation.time" label="Time" readonly v-on="on" clearable :error-messages="errors" />
                  </ValidationProvider>                    
                </template>
                <v-time-picker v-if="timeMenu" v-model="safetyObservation.time" format="24hr" full-width @click:minute="timeMenu = false" />
              </v-dialog>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="5">
              <ValidationProvider name="Location" rules="required|max:100" v-slot="{ errors }">
                <v-text-field v-model="safetyObservation.location" label="Location" counter="100" :error-messages="errors" />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="5">
              <ValidationProvider name="Non-conformance Type" rules="required" v-slot="{ errors }">
                <v-select v-model="safetyObservation.nonConformanceType"
                          :items="safetyObservationNonConformanceTypes"
                          label="Non-conformance Type"
                          clearable
                          :error-messages="errors"/>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="10">
              <ValidationProvider name="Description" rules="required|max:1000" v-slot="{ errors }">
                <v-textarea v-model="safetyObservation.description" label="Description" counter="1000" :error-messages="errors" />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FormToolbar from '../ui/FormToolbar.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'SafetyObservationForm',
  components: { FormToolbar, ValidationObserver, ValidationProvider },
  props: {
    safetyObservation: { type: Object, required: true },
    onSubmitClick: { type: Function, required: true },
    onCloseButtonClick: { type: Function, required: false },
    isLoading: { type: Boolean, required: false }
  },
  computed: {
    ...mapGetters({
      getActiveSiteConfig: 'userStore/getActiveSiteConfig',
    }),
    safetyObservationNonConformanceTypes() {
      return this.getActiveSiteConfig.safetyObservationsNonConformanceTypes;
    }
  },
  data() {
    return {
      dateMenu: false,
      timeMenu: false
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate()
        .then(isValid => isValid ? Promise.resolve() : Promise.reject())
        .then(this.onSubmitClick)
        .then(this.$refs.form.reset); // Clean up the validation state for next time
    },
    observationDateSelected() {
      this.dateMenu = false;
      this.$nextTick(() => this.timeMenu = true);
    },
    close() {
      this.onCloseButtonClick();
      this.$refs.form.reset(); // Clean up the validation state for next time
    },
    getTitle() {
      return this.safetyObservation.id || this.safetyObservation.idc ? 'Update Safety Observation' : 'Add Safety Observation';
    }
  }
};
</script>
